import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPen = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8067 2.69471C14.0667 2.43474 14.0667 2.01478 13.8067 1.75481L12.2467 0.19497C12.1221 0.070148 11.953 0 11.7767 0C11.6003 0 11.4312 0.070148 11.3067 0.19497L10 1.5015L12.5 4.00124L13.8067 2.69471Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.66669 8.83407L9.33335 2.16809L11.8334 4.66783L5.16669 11.3338H2.66669V8.83407ZM4 10.0006H4.61333L9.94667 4.66784L9.33333 4.05457L4 9.38735V10.0006Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 13.3336H0V16H16V13.3336Z",
			fill: "currentColor"
		})
	]
});
export default SvgPen;
